import angular from 'angular';
import translate from './translate.filter';
/**
 * @desc  Module initialize.
 *
 * @ngInject
 */
export default angular
  .module('app.filters', [])
  .filter('translate', translate)
  .name;
